import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("查询")

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_college_entry = _resolveComponent("college-entry")
  const _component_search_bar = _resolveComponent("search-bar")
  const _component_a_layout_header = _resolveComponent("a-layout-header")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_space = _resolveComponent("a-space")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_card = _resolveComponent("a-card")
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")
  const _component_UnorderedListOutlined = _resolveComponent("UnorderedListOutlined")
  const _component_AppstoreFilled = _resolveComponent("AppstoreFilled")
  const _component_a_tabs = _resolveComponent("a-tabs")
  const _component_platform_list = _resolveComponent("platform-list")
  const _component_school_list = _resolveComponent("school-list")
  const _component_institution_list = _resolveComponent("institution-list")
  const _component_select_book_modal = _resolveComponent("select-book-modal")
  const _component_preview_modal = _resolveComponent("preview-modal")
  const _component_a_layout_content = _resolveComponent("a-layout-content")
  const _component_a_layout = _resolveComponent("a-layout")

  return (_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { class: "head_body" }, {
        default: _withCtx(() => [
          _createVNode(_component_search_bar, {
            value: $setup.queryParams.name,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => ($setup.queryParams.name = $event)),
            onSearch: $setup.handleSearch,
            onKeyup: _withKeys($setup.handleSearch, ["enter"])
          }, {
            suffix: _withCtx(() => [
              _createVNode(_component_college_entry)
            ]),
            _: 1
          }, 8, ["value", "onSearch", "onKeyup"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, { class: "content_body" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                size: "small",
                layout: "inline",
                onKeyup: _withKeys($setup.handleSearch, ["enter"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    gutter: [16, 16],
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "标签" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                value: $setup.queryParams.tag,
                                "onUpdate:value": _cache[1] || (_cache[1] = $event => ($setup.queryParams.tag = $event)),
                                mode: "multiple",
                                placeholder: "可选择标签",
                                options: $setup.tagOpts,
                                onSearch: $setup.handleTagSearch
                              }, null, 8, ["value", "options", "onSearch"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "课件类型" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                mode: "multiple",
                                value: $setup.queryParams.types,
                                "onUpdate:value": _cache[2] || (_cache[2] = $event => ($setup.queryParams.types = $event)),
                                options: $setup.CoursewareTypeOpts,
                                placeholder: "可选择课件类型"
                              }, null, 8, ["value", "options"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      ($setup.currentTable === 'platform')
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 0,
                            md: 8,
                            sm: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { label: "排序方式" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    allowClear: true,
                                    value: $setup.queryParams.sort,
                                    "onUpdate:value": _cache[3] || (_cache[3] = $event => ($setup.queryParams.sort = $event)),
                                    options: $setup.CoursewareSortOpts,
                                    placeholder: "可选择排序方式"
                                  }, null, 8, ["value", "options"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      ($setup.currentTable !== 'platform')
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 1,
                            md: 8,
                            sm: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { label: "学科" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    placeholder: "请选择学科",
                                    options: $setup.subjectOpts,
                                    value: $setup.queryParams.subject_cat_id,
                                    "onUpdate:value": _cache[4] || (_cache[4] = $event => ($setup.queryParams.subject_cat_id = $event)),
                                    allowClear: ""
                                  }, null, 8, ["options", "value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      ($setup.currentTable !== 'platform')
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 2,
                            md: 8,
                            sm: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { label: "出版社" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select, {
                                    placeholder: "请选择出版社",
                                    options: $setup.pressVersionOpts,
                                    value: $setup.queryParams.press_version_cat_id,
                                    "onUpdate:value": _cache[5] || (_cache[5] = $event => ($setup.queryParams.press_version_cat_id = $event)),
                                    allowClear: ""
                                  }, null, 8, ["options", "value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      ($setup.currentTable !== 'platform')
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 3,
                            md: 8,
                            sm: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { label: "作者" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    placeholder: "请输入作者",
                                    value: $setup.queryParams.author_name,
                                    "onUpdate:value": _cache[6] || (_cache[6] = $event => ($setup.queryParams.author_name = $event))
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "所属教材-章节" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: _cache[7] || (_cache[7] = (...args) => ($setup.handleShowBookSelectModal && $setup.handleShowBookSelectModal(...args)))
                              }, _toDisplayString($setup.bookShowName || "教材名称-章节目录"), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: $setup.currentTable !== 'platform' ? 24 : 16,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { style: {"float":"right"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_space, { size: 20 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, { onClick: $setup.handleResetForm }, {
                                    default: _withCtx(() => [
                                      _hoisted_1
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]),
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    onClick: $setup.handleSearch
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_2
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["md"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onKeyup"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_card, { style: {"margin-top":"20px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, {
                activeKey: $setup.currentTable,
                "onUpdate:activeKey": _cache[10] || (_cache[10] = $event => ($setup.currentTable = $event))
              }, {
                tabBarExtraContent: _withCtx(() => [
                  _createElementVNode("div", {
                    style: _normalizeStyle({ color: $setup.store.state.themeColor })
                  }, [
                    ($setup.listType === $setup.ListTypeMap.CARD)
                      ? (_openBlock(), _createBlock(_component_UnorderedListOutlined, {
                          key: 0,
                          style: {"font-size":"24px","margin":"4px 8px 0 0"},
                          onClick: _cache[8] || (_cache[8] = () => ($setup.listType = $setup.ListTypeMap.LIST))
                        }))
                      : _createCommentVNode("", true),
                    ($setup.listType === $setup.ListTypeMap.LIST)
                      ? (_openBlock(), _createBlock(_component_AppstoreFilled, {
                          key: 1,
                          style: {"font-size":"24px","margin":"4px 8px 0 0"},
                          onClick: _cache[9] || (_cache[9] = () => ($setup.listType = $setup.ListTypeMap.CARD))
                        }))
                      : _createCommentVNode("", true)
                  ], 4)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tableTabOpts, (tab) => {
                    return (_openBlock(), _createBlock(_component_a_tab_pane, {
                      key: tab.value,
                      tab: tab.label
                    }, null, 8, ["tab"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["activeKey"]),
              ($setup.currentTable === $setup.TableTypeMap.PLATFROM)
                ? (_openBlock(), _createBlock(_component_platform_list, {
                    key: 0,
                    ref: "platformTableRef",
                    form: $setup.queryParams,
                    type: $setup.listType,
                    onOnPreview: $setup.handlePreview,
                    contextPage: $setup.contextPage,
                    "onUpdate:contextPage": _cache[11] || (_cache[11] = $event => ($setup.contextPage = $event)),
                    checkPersonalCloudSpace: $setup.checkPersonalCloudSpace
                  }, null, 8, ["form", "type", "onOnPreview", "contextPage", "checkPersonalCloudSpace"]))
                : _createCommentVNode("", true),
              ($setup.currentTable === $setup.TableTypeMap.SCHOOL)
                ? (_openBlock(), _createBlock(_component_school_list, {
                    key: 1,
                    ref: "schoolTableRef",
                    form: $setup.queryParams,
                    type: $setup.listType,
                    onOnPreview: $setup.handlePreview,
                    contextPage: $setup.contextPage,
                    "onUpdate:contextPage": _cache[12] || (_cache[12] = $event => ($setup.contextPage = $event)),
                    checkPersonalCloudSpace: $setup.checkPersonalCloudSpace
                  }, null, 8, ["form", "type", "onOnPreview", "contextPage", "checkPersonalCloudSpace"]))
                : _createCommentVNode("", true),
              ($setup.currentTable === $setup.TableTypeMap.INSTITUTION)
                ? (_openBlock(), _createBlock(_component_institution_list, {
                    key: 2,
                    ref: "institutionTableRef",
                    form: $setup.queryParams,
                    type: $setup.listType,
                    onOnPreview: $setup.handlePreview,
                    contextPage: $setup.contextPage,
                    "onUpdate:contextPage": _cache[13] || (_cache[13] = $event => ($setup.contextPage = $event)),
                    checkPersonalCloudSpace: $setup.checkPersonalCloudSpace
                  }, null, 8, ["form", "type", "onOnPreview", "contextPage", "checkPersonalCloudSpace"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_select_book_modal, {
            ref: "modalRef",
            type: $setup.bookType.OFFICIAL,
            visible: $setup.bookModalVisible,
            "onUpdate:visible": _cache[14] || (_cache[14] = $event => ($setup.bookModalVisible = $event)),
            onOk: $setup.handleSelectBookSection,
            queryParams: { show_modules: $setup.moduleCodeEnum.standardCourse }
          }, null, 8, ["type", "visible", "onOk", "queryParams"]),
          _createVNode(_component_preview_modal, {
            "current-preview": $setup.currentInfo,
            visible: $setup.previewVisible,
            onOnCancel: $setup.handleCancelPreview
          }, null, 8, ["current-preview", "visible", "onOnCancel"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}